
import React from "react";
import MarketplaceLayout from "../../layouts/MarketplaceLayout";
import DevelopersPage from "./DevelopersPage";

export default function DevelopersMain() {
  return (
    <MarketplaceLayout>
      <DevelopersPage />
    </MarketplaceLayout>
  );
}